import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiError } from 'src/api';
import { createAsyncThunkFromFetch } from 'src/store/utils';
import {
  fetchCompaniesStatisticsApi,
  fetchUserProfile as getUserProfile,
  postLogin,
  postLogout,
  recoveryPasswordAPI,
  resetPasswordAPI,
} from './auth.api';
import { CompaniesStatisticsResponse, LoginData } from './auth.types';

const sliceName = 'auth';

export const fetchAccountAction = createAsyncThunk(
  `${sliceName}/account`,
  async (params, thunkAPI) => {
    const response = await getUserProfile();

    if (response.status >= 400) {
      if (!response || response.status >= 400) {
        return thunkAPI.rejectWithValue({
          code: 'error.unknownError',
          ...(<ApiError>response?.data || {}),
        });
      }
    }

    if (response.data.code) {
      return thunkAPI.rejectWithValue({ user: response.data });
    }

    return { user: response.data };
  },
);

export const logoutAction = createAsyncThunk(
  `${sliceName}/logout`,
  async () => {
    const response = await postLogout();
    return response.data;
  },
);

export const loginAction = createAsyncThunk(
  `${sliceName}/login`,
  async (params: LoginData, thunkAPI) => {
    const response = await postLogin(params);

    if (!response || response.status >= 400) {
      return thunkAPI.rejectWithValue({
        code: 'error.unknownError',
        ...(<ApiError>response?.data || {}),
      });
    }

    if (response.data.code) {
      return thunkAPI.rejectWithValue({ ...response.data });
    }

    await thunkAPI.dispatch(fetchAccountAction());
    return { ...response.data };
  },
);

export const recoveryPasswordAction = createAsyncThunkFromFetch(
  `${sliceName}/recoveryPassword`,
  recoveryPasswordAPI,
);
export const resetPasswordAction = createAsyncThunkFromFetch(
  `${sliceName}/resetPassword`,
  resetPasswordAPI,
);

export const fetchCompaniesStatisticsAction = createAsyncThunkFromFetch<
  CompaniesStatisticsResponse,
  undefined
>(`${sliceName}/companies/statistics`, fetchCompaniesStatisticsApi);
